import '.ah{flex-shrink:0;}.ssr-plugin'
import '.ac{padding:1rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ak{height:100%;}.ssr-plugin'
import '.b6{border:none;}.ssr-plugin'
import '.cy{background-color:transparent;}.ssr-plugin'
import '.cz{border-radius:0px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.bm{position:sticky;}.ssr-plugin'
import '.d0{top:4rem;}.ssr-plugin'
import '.d1{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.d2{padding-bottom:1rem;}.ssr-plugin'
import '.cj{margin-bottom:1rem;}.ssr-plugin'
import '.d3{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.i{position:fixed;}.ssr-plugin'
import '.bn{top:0px;}.ssr-plugin'
import '.bu{left:0px;}.ssr-plugin'
import '.bv{right:0px;}.ssr-plugin'
import '.bw{bottom:0px;}.ssr-plugin'
import '.d4{z-index:9999;}.ssr-plugin'
import '.d5{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bl{justify-content:flex-end;}.ssr-plugin'
import '.al{flex:1;}.ssr-plugin'
import '.c5{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ah ac n ak b6 cy cz"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="d e a8"
    >
      <div className="bm d0 d1 t d2 cj d3 d"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="i bn bu bv bw d4 t d5 d e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="ac d bl d3"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="al c5">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
